import axios, { AxiosResponse } from "axios";
import cookies from "js-cookie";

const baseURL = window.location.origin;

export const request = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${cookies.get("token")}`,
  },
});

// Request instance для JSON
export const jsonRequest = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("token")}`,
  },
});

export type TUploadedFile = {
  createdAt: Date;
  id: string;
  UserId: string;
  name: string;
  path: string;
  link: string;
  mimeType: string;
};

class FileController {
  static upload = (formData: FormData): Promise<AxiosResponse<TUploadedFile>> =>
    request.post("api/files/upload", formData);

  static updateZdPersonalFiles = (
    planReportId: string,
    dealerId: string,
    fileIds: string[]
  ): Promise<AxiosResponse<boolean>> =>
    jsonRequest.put("api/zdpersonal/files", {
      planReportId,
      dealerId,
      fileIds,
    });
}

export default FileController;
